var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "panel sluzebka_inside col-lg-8 col-xl-9 col-sm-8 col-xs-12",
    },
    [
      _c("div", { staticClass: "panel-hdr" }, [
        _c("h2", [
          _vm._v("Превью\n            "),
          _c("sup", [
            _c("span", { staticClass: "badge badge-warning ml-2" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.out_number) +
                  "\n                "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "panel-toolbar ml-2" }, [
          _c("h5", { staticClass: "m-0" }, [
            _c(
              "span",
              {
                staticClass:
                  "badge badge-primary fw-400 l-h-n cursor-pointer hidden-md-down",
                on: { click: _vm.go_back },
              },
              [
                _vm._v(
                  "\n                   Повернутися назад\n                "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "panel-container show" }, [
        _c("div", { staticClass: "panel-content" }, [
          _c("div", { staticClass: "head_mem" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm.obj_to_null(_vm.organization)
              ? _c("div", { staticClass: "organization_section" }, [
                  _c("div", { staticClass: "tov" }, [
                    _c("div", { staticClass: "sluz_number" }, [
                      _c("div", { staticClass: "out_numb text-right small" }, [
                        _vm._v(_vm._s(_vm.out_number)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clr" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "title tov_new" }, [
                    _c("h1", [_vm._v(_vm._s(_vm.organization.title))]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.obj_to_null(_vm.recipient)
              ? _c(
                  "div",
                  { staticClass: "tov w-50 width-mobile-full float-right" },
                  [
                    _c("div", { staticClass: "to" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "dolzn border border-left-0 border-right-0 border-top-0 border-dark mt-2",
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.recipient.dolznost) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "fio border border-left-0 border-right-0 border-top-0 border-dark mt-2",
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.recipient.fio) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "clr" }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "body_sluz" },
            [_c(_vm.cur_addon, { tag: "component" })],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 mb-2 mt-3 pt-3 row justify-content-between",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3",
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-lg btn-block btn-outline-success waves-effect waves-themed",
                  attrs: { disabled: _vm.is_save_inactive },
                  on: {
                    click: function ($event) {
                      return _vm.save("simple")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "fal fa-download mr-1" }),
                  _vm._v("\n                На Погодження\n            "),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3",
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-lg btn-block btn-outline-info waves-effect waves-themed",
                  attrs: { disabled: _vm.is_save_inactive },
                  on: {
                    click: function ($event) {
                      return _vm.save("pre")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "fal fa-eject mr-1" }),
                  _vm._v("\n                В Чернетку\n            "),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-xs-12 col-lg-4 btn-block col-sm-4 col-xl-3 mt-3",
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-lg btn-block btn-outline-primary waves-effect waves-themed",
                  on: { click: _vm.go_back },
                },
                [_vm._v("\n                Повернутися назад\n            ")]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "head" }, [
      _c("div", { staticClass: "logo" }, [
        _c("div", { staticClass: "img" }),
        _vm._v(" "),
        _c("div", { staticClass: "clr" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }